import { ComponentProps, FC, useCallback, useEffect } from "react"
import { IHallBooking } from "src/domain/entities"
import { hallBookingAddService } from "src/domain/services/hallBooking/hallBookingAddService"
import { useAuth, useContactListService, useLocationListService } from "src/hooks"
import { FormikOnSubmit } from "src/utils/types"
import { HallBookingAddDrawerFormView, IHallBookingAddFormFields } from "."
import moment from "moment"

interface Props
	extends Omit<
		ComponentProps<typeof HallBookingAddDrawerFormView>,
		"handleSubmit" | "locationList" | "contactList"
	> {
	onSuccess: (item: IHallBooking) => void
}

export const HallBookingAddDrawerFormController: FC<Props> = ({ onSuccess, ...rest }) => {
	const { token } = useAuth()

	const { locationList, fetchLocationList } = useLocationListService()
	const { contactList, fetchContactList } = useContactListService()
	const handleSubmit = useCallback<FormikOnSubmit<IHallBookingAddFormFields>>(
		async (values, { setErrors }) => {
			try {
				const hallBooking = await hallBookingAddService(
					{
						...values,
						startDate: moment(values.startDate).unix() * 1000,
						endDate: moment(values.endDate).unix() * 1000,
					},
					token,
				)
				onSuccess(hallBooking)
				rest.onClose()
			} catch (err) {
				const message =
					err instanceof Error ? err.message : "Something went wrong"
				setErrors({ reason: message })
			}
		},
		[onSuccess, rest, token],
	)

	useEffect(() => {
		fetchLocationList()
	}, [fetchLocationList])

	useEffect(() => {
		fetchContactList()
	}, [fetchContactList])

	return (
		<HallBookingAddDrawerFormView
			handleSubmit={handleSubmit}
			locationList={locationList}
			contactList={contactList}
			{...rest}
		/>
	)
}
